module.exports = __webpack_public_path__ + "img/mushroom-mobile.a2bff542.png";